var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1149_3026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.4 9.40605H6.6C7.37 9.40605 8 10.0361 8 10.8061V17.8061C8 18.5761 7.37 19.2061 6.6 19.2061H6.4C5.63 19.2061 5 18.5761 5 17.8061V10.8061C5 10.0361 5.63 9.40605 6.4 9.40605ZM12 5.20605C12.77 5.20605 13.4 5.83605 13.4 6.60605V17.8061C13.4 18.5761 12.77 19.2061 12 19.2061C11.23 19.2061 10.6 18.5761 10.6 17.8061V6.60605C10.6 5.83605 11.23 5.20605 12 5.20605ZM17.6 13.2061C18.37 13.2061 19 13.8361 19 14.6061V17.8061C19 18.5761 18.37 19.2061 17.6 19.2061C16.83 19.2061 16.2 18.5761 16.2 17.8061V14.6061C16.2 13.8361 16.83 13.2061 17.6 13.2061Z",
    fill: "#343434"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1149_3026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.206055)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/bar_chart.d5b3415cceac9c1e2a4af2967893221f.svg";
export { ForwardRef as ReactComponent };